







































































import {Component, PropSync, Vue} from 'vue-property-decorator'
import {EventUpsertForm} from "@/form/TmodelForm";
import {EventType} from '@/model/ThingModel';
import CudParamItems from "@/component/Thing/cud-param-items.vue";
import JsonEditor from '@/component/JsonEditor/index.vue'
import _ from 'lodash'
import {NotifyPlatform} from "@/module/notify/NotifyPlatform";
import DeviceDebugApi, {DdebugNotifyByWxOaForm} from "@/module/device/DeviceDebugApi";
import {Container} from "typescript-ioc";
import berror from "biz-ts/src/error/BizError";
import deviceModule from "@/store/module/DeviceModule";
import NotifyTemplate from "@/module/notify/NotifyTemplate";

@Component({
  components: {
    CudParamItems,
    JsonEditor,
  },
})
export default class EventUpsertFormItems extends Vue {

  private ddebugApi = Container.get(DeviceDebugApi)

  @PropSync('upsertForm')
  private form!: EventUpsertForm

  private EventType = EventType

  private activeTab = 'WX_OA'

  created() {
    this.assignNotifyArgs()
  }

  private notifyArgs: { [key: string]: string } = {}

  private assignNotifyArgs(reset = false) {
    if (reset) this.notifyArgs = {}
    this.form.outputParamProxies.forEach(proxy => {
      this.notifyArgs[proxy.identifier] = ""
    })
  }

  private onParamProxiesChange() {
    this.assignNotifyArgs(true)
  }

  private onChange(notifyUser: boolean) {
    const templates = this.form.notify.templates
    if (notifyUser && templates.length == 0)
      templates.push({
        platform: NotifyPlatform.WX_OA_NOTIFY,
        id: '1r9hvySVoCrnBLHQd8IKWV6rOK_2b8qkeajbT76o2hA',
        content: {
          first: "标题",
          keyword1: "{device.alias}",
          keyword2: "告警内容",
          keyword3: "{now}",
          remark: "备注"
        },
        condition: ""
      })
  }

  private get wxOaNotifyTemplate() {
    return _.find(this.form.notify.templates, (it) => {
      return it.platform == NotifyPlatform.WX_OA_NOTIFY
    }) as NotifyTemplate
  }

  private get messageNotifyTemplate() {
    return _.find(this.form.notify.templates, (it) => {
      return it.platform == NotifyPlatform.MESSAGE_NOTIFY
    })
  }

  private deviceOrNull() {
    return deviceModule.activeOrNull
  }

  private deviceId?: number = this.deviceOrNull()?.id

  private notifyByWxOa() {
    if (this.deviceId == undefined) berror("请填写设备 ID")
    const form: DdebugNotifyByWxOaForm = {
      deviceId: this.deviceId,
      paramProxies: this.form.outputParamProxies,
      args: this.notifyArgs,
      template: this.wxOaNotifyTemplate!!
    }
    this.ddebugApi.notifyByWxOa(form)
  }
}
